<template>
  <div class="gray-back" style="padding:.2rem 0 1rem 0 ">
    <van-cell-group>
      <van-cell title="单位" :value="row.danwei"/>
      <van-cell title="联系人" :value="row.ldname"/>
      <van-cell title="微信号" :value="row.weixin"/>
      <van-cell title="手机号" :value="row.phone"/>
      <van-cell title="邮箱" :value="row.email"/>
      <van-cell title="省市" :value="row.county?row.province+'/'+row.city+'/'+row.county:''"/>
      <van-cell title="地址" :value="row.address"/>
      <van-cell title="报名状态">
        <div v-if="row.memberstatus==1">联系人信息</div>
        <div v-else-if="row.memberstatus==2">人员信息</div>
        <div v-else-if="row.memberstatus==3">申报信息</div>
        <div v-else-if="row.memberstatus==4">确认订单</div>
        <div v-else-if="row.memberstatus==6">报名成功</div>
      </van-cell>
    </van-cell-group>
    <div v-for="(item,index) in row.member_list">
      <van-divider>人员信息{{index+1}}</van-divider>
      <van-cell-group>
        <van-cell title="姓名" :value="item.name"/>
        <van-cell title="性别" :value="item.sex"/>
        <van-cell title="身份证号" :value="item.num"/>
        <van-cell title="成绩"  v-show="item.chengji" :value="item.chengji"/>
        <van-cell title="裁判长成绩" v-show="item.cpj_chengji" :value="item.cpj_chengji"/>
        <van-cell title="电话" :value="item.phone"/>
        <van-cell title="微信" :value="item.weixin"/>
        <van-cell title="套餐" :value="'('+item.service_name+')' + ' ¥' +item.price"/>
      </van-cell-group>
    </div>
    <van-divider>发票信息</van-divider>
    <van-cell title="抬头" :value="row.fapiao_taitou"/>
    <van-cell title="税号" :value="row.fapiao_shuihao"/>
    <van-cell title="发票备注" :value="row.fapiao_beizhu"/>
    <van-cell title="接收邮箱" :value="row.fapiao_email"/>
    <van-cell title="接收手机" :value="row.fapiao_phone"/>
  </div>
</template>

<style scoped="">
</style>
<script>
import {
  Cell, CellGroup, Field, RadioGroup, Radio, DatetimePicker, Picker, NoticeBar, Button, Dialog, Uploader
} from 'vant';

export default {
  name: 'WyhHuiyiApplyDetail',
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Field.name]: Field,
    [DatetimePicker.name]: DatetimePicker,
    [Picker.name]: Picker,
    [NoticeBar.name]: NoticeBar,
    [Button.name]: Button,
    [Dialog.name]: Dialog,
    [Uploader.name]: Uploader,
  },
  data: function () {
    return {
      row: {
        changdipic:[],
        zhizhaopic:[],
        kaoji_yanshoufile:[],
      },
      formData: {
        'id': this.$route.query.id,
      },
      showTime: false,
      timeField: '',
      showStation: false,
      stationField: '',
      loadding: false,
    }
  },
  mounted: function () {
    let that = this;
    document.title = "会议报名记录详情";
    this.$api.get('/wyhadminapi/huiyi/applyDetail', {
      'id': that.$route.query.id
    }, r => {
      this.row = r.data;
      console.log(this.row)
    });

  },

  methods: {
    save: function () {
      let that = this;
      Dialog.confirm({
        title: '确认',
        message: '您确定信息准确无误吗?提交后不得修改!'
      }).then(() => {
        // on confirm
        that.$api.post('/api/sai/confirmzhixuceaction', this.formData, r => {
          that.$router.push({'name': 'saiConfirm', 'query': {'id': that.row.id}});
        }, r => {
          that.$toast.fail(r.msg);
        });
      }).catch(() => {
        // on cancel
      });


    },
    edit: function () {
      let that = this;
      this.$router.push({
        'name': 'saiConfirmQr1',
        'query': {'id': that.row.id}
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// HuiyiApplyDetail.vue?4c7df707